import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import { AnalyticsService } from '../../services/analytics.service';
import axios from 'axios';
import './form-item-cmb-eligibility-need-help.component.scss';
import * as $ from 'jquery';
var FormItemCmbEligibilityNeedHelp = /** @class */ (function (_super) {
    tslib_1.__extends(FormItemCmbEligibilityNeedHelp, _super);
    function FormItemCmbEligibilityNeedHelp(element) {
        return _super.call(this, element) || this;
    }
    FormItemCmbEligibilityNeedHelp.prototype.init = function () {
        this.form = this.element.querySelector('form');
        this.selectTitle = this.element.querySelector('.js-title');
        this.buttonSubmit = Array.from(this.element.querySelectorAll('.js-apply-now__button'));
    };
    FormItemCmbEligibilityNeedHelp.prototype.bindEvents = function () {
        var _this = this;
        this.selectTitle.addEventListener('change', function (event) {
            var element = event.target;
            _this.addMoreTitle(element);
        });
        this.buttonSubmit.map(function (item) { return item.addEventListener('click', function (event) {
            var formFields = _this.form.querySelectorAll('input, select, textarea');
            var validation = _this.validationService.validate(formFields);
            if (validation.valid) {
                _this.actionForm(_this.form, _this.element.querySelector('.form__loader--container'), _this.element.querySelector('.form__thankyou--container'));
            }
        }); });
        $(document).on('click', '.js-apply-now-modal-open', function (event) {
            var element = event.target;
            var modal = $(element).attr('data-modal');
            if (modal) {
                _this.callmebackFormId = modal;
            }
        });
    };
    FormItemCmbEligibilityNeedHelp.prototype.addMoreTitle = function (element) {
        if (element) {
            if (element.value == 'Other') {
                var parentParent = element.closest('.form__fields--container');
                var parent_1 = element.closest('.form__group');
                var newContainer = document.createElement('div');
                newContainer.classList.add('form__group');
                newContainer.classList.add('js-other-title-container');
                var newLabel = document.createElement('label');
                newLabel.classList.add('form__label');
                newLabel.innerHTML = 'Other Title';
                newContainer.appendChild(newLabel);
                var newInput = document.createElement('input');
                newInput.classList.add('js-other-title');
                newInput.classList.add('form__input');
                newInput.classList.add('form__input--required');
                newInput.setAttribute('placeholder', 'Enter your title');
                newInput.setAttribute('maxlength', '4');
                newInput.setAttribute('name', 'other-title');
                newContainer.appendChild(newInput);
                parentParent.insertBefore(newContainer, parent_1.nextSibling);
            }
            else {
                var parentParent = element.closest('.form__fields--container');
                var oldInput = this.element.querySelector('.js-other-title-container');
                if (oldInput) {
                    parentParent.removeChild(oldInput);
                }
            }
        }
    };
    FormItemCmbEligibilityNeedHelp.prototype.resetForm = function () {
        if (this.form) {
            this.form.reset();
            var formContainerLoader = this.element.querySelector('.form__loader--container');
            var formContainerFields = this.element.querySelector('.form__fields--container');
            var formContainerThankyou = this.element.querySelector('.form__thankyou--container');
            formContainerThankyou.classList.remove('active');
            formContainerFields.classList.remove('hidden');
        }
    };
    FormItemCmbEligibilityNeedHelp.prototype.actionForm = function (form, loader, thankyou) {
        // fields
        var title = this.form.querySelector('select[name=title]');
        var titleOther = form.querySelector('input[name=other-title]');
        var firstName = form.querySelector('input[name=first-name]');
        var surname = form.querySelector('input[name=surname');
        var dailingCode = form.querySelector('select[name=dailing-code');
        var telephone = form.querySelector('input[name=telephone');
        var email = form.querySelector('input[name=email');
        var comments = form.querySelector('textarea[name=comments');
        var pageUrl = window.location.href;
        var postData = '';
        if (title) {
            if (titleOther) {
                postData += 'title=' + titleOther.value + '&';
            }
            else {
                postData += 'title=' + title.value + '&';
            }
        }
        if (firstName) {
            postData += 'firstName=' + firstName.value + '&';
        }
        if (surname) {
            postData += 'surname=' + surname.value + '&';
        }
        if (dailingCode) {
            postData += 'dialCode=' + dailingCode.value + '&';
        }
        if (telephone) {
            postData += 'tel=' + telephone.value + '&';
        }
        if (email) {
            postData += 'email=' + email.value + '&';
        }
        if (comments) {
            postData += 'comments=' + comments.value + '&';
        }
        if (this.callmebackFormId) {
            postData += 'callmebackFormId=' + this.callmebackFormId + '&';
        }
        if (pageUrl) {
            postData += 'pageUrl=' + pageUrl + '&';
        }
        // loader + hide form
        var fieldsContainer = form.querySelector('.form__fields--container');
        loader.classList.add('active');
        fieldsContainer.classList.add('hidden');
        // variables
        var analyticsService = new AnalyticsService();
        var url = "/services/Feedback.jsp";
        var config = {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        // service
        axios.post(url, postData, config).then(function (response) {
            // service ok
            loader.classList.remove('active');
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        }).catch(function (response) {
            // service failed
            analyticsService.dtmFormComplete('complete', '');
            loader.classList.remove('active');
            thankyou.classList.add('active');
        });
    };
    return FormItemCmbEligibilityNeedHelp;
}(Base));
export { FormItemCmbEligibilityNeedHelp };



//////////////////
// WEBPACK FOOTER
// ./components/form-item-cmb-eligibility-need-help/form-item-cmb-eligibility-need-help.component.ts
// module id = 325
// module chunks = 0